import styled from 'styled-components';
import BasicInformation from './BasicInformation';
import ExpectedPeriod from './ExpectedPeriod';
import ExpectedBid from './ExpectedBid';
import ExpectedSaleAndProfit from './ExpectedSaleAndProfit';
import ReturnAnalysis from './ReturnAnalysis';
import QuantCheck from './QuantCheck';
import { s } from './VIPReport.style';

import { useNavigate } from 'react-router-dom';

const VIPReport = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Header>
        <img
          onClick={() => {
            navigate(-1);
          }}
          src="/assets/images/arrow/back-arrow-left-gray.svg"
        />
      </Header>
      <s.Div style={{ marginTop: '56px', marginBottom: '8px' }}>
        <HeaderDiv>
          <HeaderTop>
            <HeaderTitleDiv>
              <HeaderTitle>VIP 퀀트 투자 분석 리포트</HeaderTitle>
              <CategoryDiv>저평가주</CategoryDiv>
            </HeaderTitleDiv>
          </HeaderTop>
          <Grid>
            <InfoCell>
              <Title>사건번호</Title>
              <Content>2024타경001234</Content>
            </InfoCell>
            <InfoCell>
              <Title>소재지</Title>
              <Content>서울시 동작구</Content>
            </InfoCell>
            <InfoCell>
              <Title>부동산 종류</Title>
              <Content>빌라</Content>
            </InfoCell>
            <InfoCell>
              <Title>경매현황</Title>
              <Content>유찰 2회</Content>
            </InfoCell>
          </Grid>
        </HeaderDiv>
      </s.Div>
      <Report>
        <BasicInformation />
        <ExpectedPeriod />
        <ExpectedBid />
        <ExpectedSaleAndProfit />
        <ReturnAnalysis />
        <QuantCheck />
      </Report>
      <BottomFixed>
        <DetailPageButton>상세정보 보러가기 {'>'}</DetailPageButton>
      </BottomFixed>
    </Container>
  );
};

export default VIPReport;

const Header = styled.div`
  width: 100%;
  height: 56px;
  background-color: #ffffff;
  padding: 16px;
  position: fixed;
  top: 0;
`;

const Container = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const HeaderTitleDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222222;
`;

const CategoryDiv = styled.div`
  width: fit-content;
  padding: 4px 12px;
  background-color: #e6f3ff;
  border-radius: 4px;
  color: #008aff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
`;

const DetailPageButton = styled.div`
  min-width: 205px;
  background-color: #008aff;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const HeaderBottom = styled.div`
  width: 1020px;
  height: 99px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e8ea;
  border-radius: 16px;
`;

const HeaderBottomCategory = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 30px;
  justify-content: center;
`;

const GrayLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: #e5e8ea;
`;

const CategorySpan = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
`;

const ContentSpan = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #222222;
`;

const Report = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BottomFixed = styled.div`
  width: 100%;
  height: 94px;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  padding: 16px 16px 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #e5e8ea;
  border-radius: 16px;
  overflow: hidden;
`;

const InfoCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 0px 16px 20px;
  border-right: 1px solid #e5e8ea;
  border-bottom: 1px solid #e5e8ea;

  &:nth-child(2n) {
    border-right: none;
  }

  &:nth-last-child(-n + 2) {
    border-bottom: none;
  }
`;

const Title = styled.div`
  font-size: 12px;
  color: #008aff;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Content = styled.div`
  font-size: 14px;
  color: #222222;
  font-weight: 700;
`;
